import BackBar from "components/ui/BackBar/BackBar";
import UserControls from "pages/Profile/UserControls";
import ProfileDetail from "pages/Profile/ProfileDetail";
import useEntity from "hooks/useEntity";
import Alert from "components/ui/Alert/Alert";

function Profile() {
  const { entity, error } = useEntity(window.location.pathname, 'profile');

  if (error) {
    return <Alert message={ error }/>;
  }

  return (
    <>
      <div className="background-primary">
        <div className="wrapper--fluid">
          <BackBar label={ 'Terug naar leden zoeken pagina' }/>
        </div>
      </div>

      <div className="wrapper--fluid">
        <div className="content content--background">
          { entity && <ProfileDetail data={ entity }/> }
        </div>
      </div>

      <div className="wrapper--fluid">
        { entity && <UserControls userId={ entity.uid }/> }
      </div>
    </>
  )
}

export default Profile;
